import { createAddNodeAction, FShallowNode } from '@spazious/dollhouse-shallow-graph';

import { Commander, CommanderActionTypesEnum } from '../types.js';
import { generateSelector } from '../utils/generateSelector.js';

import { GraphNodeAction } from './GraphNodeAction.js';

export type AddActionPayload = FShallowNode;

export class AddAction extends GraphNodeAction<CommanderActionTypesEnum.Add, AddActionPayload> {
  constructor(commander: Commander, payload?: AddActionPayload) {
    const { prevState } = commander;
    const selector = generateSelector(1, prevState.cursor);
    super(commander, CommanderActionTypesEnum.Add, selector, payload);
  }

  _apply(): void {
    const { staging } = this.commander;

    if (!this.payload) {
      throw new Error('Payload is required for AddAction');
    }

    const selector = this.selector();

    staging.abort();

    staging.add(
      createAddNodeAction(selector, {
        ...this.payload,
      })
    );
  }
}
